import { graphql } from "@server/gql";

export default graphql(/* GraphQL */ `
  query KeyValue(
    $locale: String!
    $keys: [String] = null
    $preview: Boolean
    $limit: Int = 2000
  ) {
    keyValueCollection(
      locale: $locale
      where: { key_in: $keys }
      preview: $preview
      limit: $limit
    ) {
      items {
        key
        value
      }
    }
  }
`);
